import apiService from '@/util/request';
import SMP_CONFIG from '@/util/smp_config';

const cardessBase = SMP_CONFIG.hostConfig.apiHost.indexOf('-dev') > -1 || SMP_CONFIG.hostConfig.apiHost.indexOf('-stage') > -1 ? 'https://api.stage.cardess.com' : 'https://api.cardess.com';
const getContactInfo = (token, mandantId) => {
  return apiService.get(`${cardessBase}/engage-proxy/customer-by-token`, { params: { token, mandantId } }).then(({ data }) => {
    const customer = data.customer;
    const vehicle = data.vehicles[0];
    const tyre = vehicle?.tyresSet[0];

    return {
      customer: customer?.customerId || null,
      salutation: customer?.salutation || null,
      lastname: customer?.lastName || null,
      firstname: customer?.firstName || null,
      numberPlate: vehicle?.licencePlate || null,
      phone: customer?.privateMobile || customer?.businessMobile || null,
      email: customer?.email || null,
      storage: tyre?.storagePlace || null,
      companyName: customer?.companyName
    };
  });
};

const requestIdentifyLicensePlateFromEngage = (licensePlate) => {
  if (!licensePlate || licensePlate === '') {
    throw Error('License plate is required!');
  }

  const engageMandantId =
    SMP_CONFIG.contextConfig &&
    SMP_CONFIG.contextConfig.extended &&
    SMP_CONFIG.contextConfig.extended.featureConfig &&
    SMP_CONFIG.contextConfig.extended.featureConfig.engageMandantId
      ? SMP_CONFIG.contextConfig.extended.featureConfig.engageMandantId
      : null;
  if (!engageMandantId || engageMandantId === '') {
    throw new Error('Engage mandant ID is required');
  }

  const payload = {
    licensePlate: licensePlate,
    mandantId: engageMandantId,
    countryCode: SMP_CONFIG.applicationConfig.countryCode || SMP_CONFIG.countryConfig.countryCode
  };

  return apiService.post(`${cardessBase}/engage-proxy/customer-vehicle/identification`, payload).then((res) => res.data);
};

const getIdentifyLicensePlateFromEngage = (token, smsCode) => {
  if (!token || token === '') {
    throw new Error('Token is required parameter!');
  }

  if (!smsCode || smsCode === '') {
    throw new Error('SMS Code is required parameter!');
  }

  return apiService
    .get(`${cardessBase}/engage-proxy/customer-vehicle/identification/${token}`, {
      params: {
        verificationCode: smsCode
      }
    })
    .then((res) => res.data);
};

export default {
  getContactInfo,
  requestIdentifyLicensePlateFromEngage,
  getIdentifyLicensePlateFromEngage
};
